var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "#017C71",
    stroke: "#017C71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9683 24.4191L16.3924 24.7429M16.3924 24.7429L17.5693 25.6416C18.0321 25.995 18.6835 25.9583 19.1037 25.5552V25.5552C20.0664 24.6317 21.5637 25.7988 20.9525 26.9846V26.9846C20.6886 27.4967 20.8272 28.1294 21.2851 28.4791L22.9652 29.762L24.1378 30.6575C24.8582 31.2076 25.9052 30.7963 26.0585 29.903L26.4513 27.6143L27.1812 23.3618L28.2511 17.1279C28.4158 16.1686 27.4347 15.4194 26.5526 15.8309L20.8205 18.5046L16.9102 20.3285L14.8058 21.3101C13.9844 21.6932 13.8633 22.8116 14.5836 23.3617L16.3924 24.7429Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.20609
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.93a9b7e53a3e7262740eae853605f0cc.svg";
export { ForwardRef as ReactComponent };